import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper fill-height"},[_c(VContainer,{staticClass:"fill-height align-stretch",attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","sm":"4","lg":"3","xl":"2"}},[_c('SettingsNav',{staticClass:"with-margin d-sticky"})],1),_c(VCol,{attrs:{"cols":"12","sm":"8","lg":"9","xl":"10"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }